<script setup lang="ts">
import { Icon } from "@iconify/vue";

// accetta tutte le props che accetta Iconify
defineProps<{
  icon: string;
  height?: string | number;
  width?: string | number;
  color?: string;
}>();
</script>

<template>
  <!-- forward delle props -->
  <Icon v-bind="$props" />
</template>
